import React, { useEffect, useState } from "react";
import { Button } from "antd";

import { getPrinters, printOrder } from "../../utils/Print";
import { Order } from "../../../types/model";

interface PrintButtonProps {
  className?: string;
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
  handleError: (err: Error) => void;
  children: React.ReactNode;
  order: Order;
}

const PrintButton: React.FC<PrintButtonProps> = ({
  className,
  style,
  size,
  handleError,
  children,
  order,
}) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  // Test to see if we can reach the print agent.
  useEffect(() => {
    getPrinters((_: any, err?: Error) => {
      if (err) {
        // Do nothing, do not enable the button.
      } else {
        setDisabled(false);
      }
    });
  }, []);

  return (
    <Button
      type="primary"
      disabled={disabled}
      loading={loading}
      className={className}
      style={style}
      size={size}
      onClick={() => {
        setLoading(true);
        printOrder(
          order,
          () => {
            setLoading(false);
          },
          (err) => {
            setLoading(false);
            handleError(err);
          }
        );
      }}
    >
      {children}
    </Button>
  );
};

export default PrintButton;
